import ReactGA from 'react-ga';

export enum GACategories {
  Layer = "Layer",
  Widget = "Widget",
  Panel = "Panel",
  Modal = "Modal",
  Report = "Report",
  File = "File",
  Polygon = "Polygon",
  FeatureService = "Feature Service",
  DownloadButton = "Download Button",
}

export enum GAActions {
  TurnedOn = "Turned On",
  TurnedOff = "Turned Off",
  Opened = "Opened",
  Clicked = "Clicked",
  Printed = "Printed",
  Uploaded = "Uploaded",
  Added = "Added",
}

export default {
  initialize: () => ReactGA.initialize('UA-50139914-20'),
  event: (category: string, action: string, label: string | undefined) => ReactGA.event({ category, action, label }),
};
